export function getPointsForLevel(schwierigkeitsgrad) {
    const numeric = Number(schwierigkeitsgrad);
    if (Number.isInteger(numeric)) {
        if (numeric <= 1) return 2;
        if (numeric === 2) return 3;
        return 4;
    }
    if (typeof schwierigkeitsgrad === 'string') {
        const normalized = schwierigkeitsgrad.trim().toLowerCase();
        if (normalized === 'einfach' || normalized === 'easy' || normalized === 'leicht') return 2;
        if (normalized === 'mittel' || normalized === 'medium') return 3;
        if (normalized === 'schwer' || normalized === 'hard') return 4;
    }
    return 2;
}

/**
 * Normalisiert beliebige Schwierigkeits-Eingaben (Zahl 1–5 oder Strings) auf
 * die drei Stufen 1 (leicht), 2 (mittel), 3 (schwer).
 */
export function getDifficultyLevel(schwierigkeitsgrad) {
    const numeric = Number(schwierigkeitsgrad);
    if (Number.isFinite(numeric)) {
        if (numeric <= 1) return 1;
        if (numeric >= 3) return 3;
        return 2;
    }
    if (typeof schwierigkeitsgrad === 'string') {
        const s = schwierigkeitsgrad.trim().toLowerCase();
        if (s === 'leicht' || s === 'einfach' || s === 'easy') return 1;
        if (s === 'schwer' || s === 'hard') return 3;
        if (s === 'mittel' || s === 'medium') return 2;
    }
    return 2;
}

export function normalizeMatrixCell(cell) {
    if (!cell) return null;
    return {
        id: cell.id,
        thema: cell.thema ?? cell.kategorie ?? '',
        points: cell.points ?? getPointsForLevel(cell.schwierigkeitsgrad),
        difficulty: getDifficultyLevel(cell.schwierigkeitsgrad),
        played: cell.played ?? cell.gespielt ?? false,
        frage: cell.frage ?? '',
    };
}
